import {AnalyticsClient, type AnalyticsEvent} from "../../blink-sdk/utils/AnalyticsClient";
import {iFrameConnection} from "./IFrameConnection";
import {IFrameMessages} from "../../blink-sdk/messaging/IFrameMessages";
import {iFrameState} from "./IFrameState";


export class IFrameAnalyticsService {
    declare client?: AnalyticsClient;
    init(eventSender: string) {
        this.client = new AnalyticsClient(eventSender);

        let iFrameSelector: string | null = null;

        this.client.preprocessors.push((event) => {
            event.payload = {
                ...iFrameState.getMetadata(),
                ...event.payload,
                iFrameSelector,
            };
        });

        iFrameConnection.addListener(IFrameMessages.UPDATE_ANALYTICS_DATA_FROM_SDK, ({environment, identity, iframeSelector}: {
            environment?: Record<string, any>;
            identity?: Record<string, any>;
            iframeSelector?: string;
        }) => {
            if (environment != null) {
                this.client.environment = environment;
            }
            if (identity != null) {
                this.client.identity = identity;
            }
            if (iframeSelector != null) {
                iFrameSelector = iframeSelector;
            }
        });

        this.client.addListener("event", (event: AnalyticsEvent) => {
            iFrameConnection.sendToSDK(IFrameMessages.ANALYTICS_EVENT, {event});
        });
    }
}

export const iFrameAnalyticsService = new IFrameAnalyticsService();
